import { dayjs } from '@2wunder/klarx-tool'
import { MemberProps } from 'app/components/Core/convention'
import { uniq } from 'lodash'
import { FC } from 'react'

dayjs
const DateCell: FC<MemberProps<ILineItem>> = ({
  member: { start_date, return_date, start_time, return_time }
}) => (
  <>
    {uniq([
      dayjs(start_date).parseLocaleDate().toLocaleDate(),
      dayjs(return_date).parseLocaleDate().toLocaleDate()
    ]).join(' - ')}
    <br />
    {[start_time, return_time].filter(Boolean).join(' - ')}
  </>
)

export default DateCell
